if (!customElements.get('before-after-slider')) {
  class BeforeAfterSlider extends HTMLElement {
    connectedCallback() {
      this.afterWrapper = this.querySelector('.ba-after-wrapper');
      this.handle = this.querySelector('.ba-handle');

      this.isDragging = false;

      if (this.handle) {
        const start = parseFloat(this.dataset.start) || 50;
        this.setPosition(start);
  
        this.initEvents();
      }
    }

    setPosition(percent) {
      percent = Math.max(0, Math.min(100, percent));
      this.afterWrapper.style.width = percent + '%';
      if (this.handle) {
        this.handle.style.left = percent + '%';
      }
    }

    getPercent(clientX) {
      const rect = this.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    initEvents() {
      this.addEventListener('pointerdown', (e) => {
        this.isDragging = true;
        this.setPointerCapture(e.pointerId);
        this.move(e);
      });

      this.addEventListener('pointermove', (e) => {
        if (!this.isDragging) return;
        this.move(e);
      });

      this.addEventListener('pointerup', () => {
        this.isDragging = false;
      });

      this.addEventListener('pointerleave', () => {
        this.isDragging = false;
      });
    }

    move(e) {
      const percent = this.getPercent(e.clientX);
      this.setPosition(percent);
    }
  }

  customElements.define('before-after-slider', BeforeAfterSlider);
}